import styled from "styled-components";

export const ContainerToImage = styled.div`
  width: 1754px;
  max-width: 1754px;
  min-width: 1754px;
  height: 1240px;
  max-height: 1240px;
  min-height: 1240px;
  font-size: 40px;
`;

export const Container = styled.div`
  display: none;
`;
